import { useGetCustomDomainsQuery } from "api/TenantSlug/CustomDomain/hooks";
import { ManageCustomDomainDrawer } from "components/Drawers/ManageCustomDomainDrawer/ManageCustomDomainDrawer.tsx";
import { Table } from "components/UI/Table";
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, tableAtom } from "components/UI/Table/atoms/tableAtom";
import {FILTER_TYPES} from "components/UI/Table/constants/filter.ts";
import { useTableDataApiOperations } from "components/UI/Table/hooks/useTableDataApiOperations";
import { TableColumnType } from "components/UI/Table/types/table.ts";
import { ColumnHeaderTitle } from "components/UI/Table/UI/ColumnHeaderTitle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useRowHandlers } from "hooks/useTableRowHandlers";
import { useRecoilValue } from "recoil";
import { DrawerId, TableId } from "types/models";

import GetCustomDomainsResponse = App.Http.Responses.CustomDomain.GetCustomDomainsResponse;
import CustomDomainData = App.Data.CustomDomainData;

export const CustomDomainsTable = () => {
    const tableId = TableId.CustomDomainsTable;
    const { t: tG } = usePaldockTranslation("tables.general-columns");
    const tableAtomInstance = tableAtom<CustomDomainData>();
    const tableState = useRecoilValue(tableAtomInstance(tableId));

    const getCustomDomainsQuery = useGetCustomDomainsQuery(
        {
            page: {
                number: tableState.page?.number ?? DEFAULT_PAGE_NUMBER,
                size: tableState.page?.size ?? DEFAULT_PAGE_SIZE,
            },
            filter: {
                filter: tableState?.filter?.filter,
                sort: tableState?.filter?.sort ?? "name",
            },
        },
        {
            enabled: false,
        }
    );

    const tableFetchDataUtils = useTableDataApiOperations<GetCustomDomainsResponse>(tableId, getCustomDomainsQuery);

    const { getRowHandlers, getRowClassName } = useRowHandlers<CustomDomainData>({
        actions: [
            {
                type: "drawer",
                drawerId: DrawerId.ManageCustomDomain,
                drawerParam: "manageCustomDomain-domainId",
            },
        ],
    });

    const columnConfig: TableColumnType<CustomDomainData>[] = [
        {
            title: <ColumnHeaderTitle columnTitle={tG("name")} />,
            dataIndex: "name",
            key: "name",
            editable: true,
            sorter: true,
            defaultSorter: true,
            filterable: true,
            filterType: FILTER_TYPES.string,
            ellipsis: true,
            width: 150,
        },
    ];

    return (
        <>
            <ManageCustomDomainDrawer onSubmit={() => tableFetchDataUtils.refetchData()} />
            <Table<GetCustomDomainsResponse, CustomDomainData>
                tableId={tableId}
                data={tableFetchDataUtils.tableData as GetCustomDomainsResponse}
                dataSource={tableFetchDataUtils.tableData?.customDomains || []}
                columnConfig={columnConfig}
                showRefetchButton={true}
                loading={tableFetchDataUtils.fetchQuery.isLoading || tableFetchDataUtils.fetchQuery.isFetching}
                onRefresh={tableFetchDataUtils.refetchData}
                enableColumnsVisibility={false}
                rowKey={(record) => record.id}
                onRow={(record, rowIndex) => getRowHandlers(record, rowIndex)}
                rowClassName={(_, rowIndex) => getRowClassName(rowIndex)}
                autoScrollWidth={true}
                enableFilters={true}
                scroll={{ y: 300 }}
            />
        </>
    );
};
